/**
 * F-021 — Pause / resume controller.
 *
 * Holds a single "paused" boolean that the main loop checks before
 * stepping the simulation. Listeners (UI badge) get notified on
 * transitions. F-022 settings can wire this to a key binding.
 */

export interface PauseController {
  isPaused(): boolean;
  pause(): void;
  resume(): void;
  toggle(): void;
  onChange(listener: (paused: boolean) => void): () => void;
}

export function createPauseController(): PauseController {
  let paused = false;
  const listeners = new Set<(p: boolean) => void>();

  const announce = (next: boolean): void => {
    if (next === paused) return;
    paused = next;
    for (const l of listeners) l(paused);
  };

  return {
    isPaused: () => paused,
    pause: () => announce(true),
    resume: () => announce(false),
    toggle: () => announce(!paused),
    onChange: (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
  };
}
